var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoShareholders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 227,
    viewBox: "0 0 178 227",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145.756 82.2559H72.3379C69.4393 82.2559 67.0938 79.9103 67.0938 77.0117V3.24414C67.0938 0.345529 69.4393 -2 72.3379 -2C115.715 -2 151 33.635 151 77.0117C151 79.9103 148.654 82.2559 145.756 82.2559Z",
    fill: "#E7F0F7",
    fillOpacity: 0.29
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6216 204.174L53.2989 118.088V26.6186C53.2989 22.9118 50.373 20 46.6481 20C-8.42014 20 -54 64.4772 -54 119.279C-54 174.082 -8.42014 219 46.6481 219C48.909 219 51.0381 218.868 53.2989 218.735C63.0086 218.206 72.4531 216.087 81.6311 212.645C85.0895 211.455 86.8192 207.616 85.6216 204.174Z",
    fill: "#DEE2E8",
    fillOpacity: 0.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M104.892 206C103.865 206 102.846 205.781 101.897 205.349C100.141 204.556 98.7823 203.098 98.1023 201.3L62.4618 105.796C61.6261 103.567 61.9378 101.075 63.2902 99.1216C64.6498 97.1679 66.8726 96 69.2515 96H170.75C174.757 96 178 99.2419 178 103.248C178 148.267 149.645 189.656 107.448 205.533C106.619 205.844 105.756 206 104.892 206Z",
    fill: "#BFDDFC",
    fillOpacity: 0.18
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoShareholders);
export default __webpack_public_path__ + "static/media/logo-shareholders.37a4a3b261fafed6f6c5998803415c2d.svg";
export { ForwardRef as ReactComponent };